(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./conversationGetters", "./conversationNormalization"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./conversationGetters"), require("./conversationNormalization"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.conversationGetters, global.conversationNormalization);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _conversationGetters, _conversationNormalization) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_conversationGetters).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _conversationGetters[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _conversationGetters[key];
      }
    });
  });
  Object.keys(_conversationNormalization).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _conversationNormalization[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _conversationNormalization[key];
      }
    });
  });
});